import { createFileRoute, Link } from '@tanstack/react-router'
import { Banknote, Building2, CalendarCheck, CalendarOff, Clock, FileText, FolderOpen, GitBranch, GraduationCap, Receipt, TrendingUp, UserCheck, UserPlus, Users } from 'lucide-react'
import { ModuleGuard } from '@/components/module-guard'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'

export const Route = createFileRoute('/hr/')({
  component: HRIndexPage,
})

function HRIndexPage() {
  const navItems = [
    {
      title: 'Employees',
      description: 'Manage employee directory and profiles',
      href: '/hr/employees',
      icon: Users,
    },
    {
      title: 'Departments',
      description: 'Manage organizational departments',
      href: '/hr/departments',
      icon: Building2,
    },
    {
      title: 'Onboarding',
      description: 'Track employee onboarding progress',
      href: '/hr/onboarding',
      icon: UserCheck,
    },
    {
      title: 'Leave',
      description: 'Manage leave requests and balances',
      href: '/hr/leave',
      icon: CalendarOff,
    },
    {
      title: 'Attendance',
      description: 'Track and manage employee attendance',
      href: '/hr/attendance',
      icon: CalendarCheck,
    },
    {
      title: 'Shifts',
      description: 'Manage shift types and employee assignments',
      href: '/hr/shifts',
      icon: Clock,
    },
    {
      title: 'Performance',
      description: 'Manage performance reviews',
      href: '/hr/performance-reviews',
      icon: TrendingUp,
    },
    {
      title: 'Contracts',
      description: 'Manage employee contracts and templates',
      href: '/hr/contracts',
      icon: FileText,
    },
    {
      title: 'Documents',
      description: 'Manage employee documents and expiry tracking',
      href: '/hr/documents',
      icon: FolderOpen,
    },
    {
      title: 'Lifecycle',
      description: 'Track promotions, transfers, and separations',
      href: '/hr/lifecycle',
      icon: GitBranch,
    },
    {
      title: 'Payroll',
      description: 'Manage salary structures, components, and payroll runs',
      href: '/hr/payroll',
      icon: Banknote,
    },
    {
      title: 'Expense Claims',
      description: 'Manage employee expense reimbursements',
      href: '/hr/expense-claims',
      icon: Receipt,
    },
    {
      title: 'Recruitment',
      description: 'Manage job openings, applicants, and interviews',
      href: '/hr/recruitment',
      icon: UserPlus,
    },
    {
      title: 'Training',
      description: 'Manage training events and employee enrollments',
      href: '/hr/training',
      icon: GraduationCap,
    },
  ]

  return (
    <ModuleGuard moduleKey="hr">
      <div className="container mx-auto py-6 px-4">
        <div className="mb-6">
          <h1 className="text-2xl font-bold">Human Resources</h1>
          <p className="text-muted-foreground">Manage your organization's workforce</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {navItems.map((item) => (
            <Link key={item.title} to={item.href}>
            <Card
              className="hover:shadow-md transition-shadow cursor-pointer"
            >
              <CardHeader className="flex flex-row items-center gap-4 pb-2">
                <div className="p-2 rounded-lg bg-muted">
                  <item.icon className="h-5 w-5" />
                </div>
                <div>
                  <CardTitle className="text-lg">{item.title}</CardTitle>
                </div>
              </CardHeader>
              <CardContent>
                <CardDescription>{item.description}</CardDescription>
              </CardContent>
            </Card>
            </Link>
          ))}
        </div>
      </div>
    </ModuleGuard>
  )
}
